import { render, staticRenderFns } from "./StrategyContentLibrary.vue?vue&type=template&id=4f587154&scoped=true"
import script from "./StrategyContentLibrary.vue?vue&type=script&lang=js"
export * from "./StrategyContentLibrary.vue?vue&type=script&lang=js"
import style0 from "./StrategyContentLibrary.vue?vue&type=style&index=0&id=4f587154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f587154",
  null
  
)

export default component.exports